import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import * as Highcharts from 'highcharts';
import { SeriesPieOptions } from 'highcharts';
import Exporting from 'highcharts/modules/exporting';
import ExportData from 'highcharts/modules/export-data';
import { HighchartsChartModule } from "highcharts-angular";


Exporting(Highcharts);
ExportData(Highcharts);

/**
 * The percentage shown for a slice. Slices rounded one by one can total 101%, so the series can supply its own
 * `custom.percentage` per point; without it the slice's own percentage is rounded.
 */
function slicePercentage(point: Highcharts.Point): number {
  return point.options.custom?.['percentage'] ?? Math.round(point.percentage ?? 0);
}

@Component({
  selector: 'app-report-pie-chart',
  standalone: true,
  imports: [
    HighchartsChartModule
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `<highcharts-chart [Highcharts]="Highcharts" [options]="chartOptions" style="width: 100%; display: block;"></highcharts-chart>`
})

export class ReportPieChartComponent implements OnInit, OnChanges {
  Highcharts: typeof Highcharts = Highcharts;
  chartOptions: Highcharts.Options = {};

  @Input() series: SeriesPieOptions[] = [];

  @Output() chartReady = new EventEmitter<Highcharts.Chart>();

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['series'] && this.series) {
      this.updateChartOptions();
    }
  }


  ngOnInit(): void {
    this.updateChartOptions();
  }

  updateChartOptions() {
    const that = this;
    this.chartOptions = {
      chart: {
        type: 'pie',
        height: 416,
        width: 624,
        events: {
          load(this: Highcharts.Chart) {
            // `this` is already typed as the Chart instance
            that.chartReady.emit(this);
          }
        }
      },
      title: {
        text: undefined
      },
      credits: {
        enabled: false
      },
      tooltip: {
        pointFormatter(this: Highcharts.Point) {
          return `${this.series.name}: <b>${this.y}</b> (${slicePercentage(this)}%)`;
        }
      },
      plotOptions: {
        pie: {
          innerSize: '50%',
          startAngle: 0,
          allowPointSelect: true,
          cursor: 'pointer',
          showInLegend: true,
          dataLabels: {
            enabled: true,
            formatter(this: Highcharts.PointLabelObject) {
              return `${slicePercentage(this.point)}%`;
            },
            distance: -30,
            style: {
              fontSize: '18px',
              fontWeight: 'bold',
              color: 'white'
            }
          }
        }
      },
      legend: {
        enabled: true,
        align: 'center',
        verticalAlign: 'bottom',
        itemStyle: {
          fontSize: '18px',
        }
      },
      series: this.series.length > 0 ? this.series : []
    };
  }
}

